<template>
    <div id="main-grid" class="grid simple main borderRadius12px" style="background: #e5e9ec">
      <div class="well form-group" style="background: #e5e9ec">
  
        <!--title -->
        <div class="grid-title no-border borderTop">
          <h4 style="padding-left: 6px"> {{ i18nValues["variableEdition"] }} </h4>
        </div>        
  
        <!-- body -->
        <div class="grid-body no-border borderBottom">
          <el-form v-loading="loading != 0" :model="variable" ref="formVariable" :rules="rules">
            <div class="gridTemplate">
  
                <!-- Name -->    
                <el-form-item :label="i18nValues['name']" prop="name"> 
                  <el-input v-model="variable.name" maxlength="30"></el-input>
                </el-form-item>      

                <!-- DataType -->    
                <el-form-item :label="i18nValues['dataType']" prop="dataType"> 
                  <el-select v-model="variable.dataType" placeholder="Please select" filterable>
                    <el-option :value="null"></el-option>
                      <el-option
                      v-for="item in options"
                        :key="item.id"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                  </el-select>
                </el-form-item>  
  
                <!-- InspectionType --> 
                <el-form-item :label="i18nValues['inspectionType']" prop="inspectionType"> 
                  <el-select v-model="selectedInspectionTypeId" placeholder="Please select" filterable>
                    <el-option :value="null"></el-option>
                      <el-option
                      v-for="item in inspectionTypes"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                  </el-select>
                </el-form-item> 

            </div>          
          </el-form>

          <h6 style="padding-left: 6px" v-if="this.variable.dataType == 3"> {{ i18nValues["options"] }} </h6>

          <el-form v-if="this.variable.dataType == 3" v-loading="loading != 0" :model="option" ref="formOption" :rules="rulesOption">
            <div class="gridTemplate">
  
                <!-- Option -->    
                <el-form-item prop="name"> 
                  <el-input v-model="option.name" maxlength="30"></el-input>
                </el-form-item>      

                <!-- Add Option-->
                <el-form-item>
                  <el-button
                    @click="addOption()"
                    icon="fas fa-plus"
                    id="addOptionButton"
                    size="small"
                    class="btn-primary"
                  >
                  {{ i18nValues["addOption"] }}
                  </el-button>
                </el-form-item>
            </div>          
          </el-form>

          <!-- table -->
          <div class="full-width" style="margin:0 auto;padding:40px;">
                <el-table
                  v-if="optionsList.length > 0 && this.variable.dataType == 3"
                  :data="optionsList"
                  class="table table-hover table-striped"
                  id="optionsTable"
                  :empty-text="i18nValues['noDataAvailable']"
                  align="center"
                >
                  <!-- Option Name -->
                  <el-table-column
                    prop="name"
                    :label= "i18nValues['name']"
                    width="75"
                    align="center"
                    sortable
                    draggable 
                  ></el-table-column>

                  <!-- REMOVE -->
                  <el-table-column width="90" align="right">
                    <template slot-scope="scope">
                      <el-button
                        class="text-danger"
                        icon="fas fa-times"
                        size="small"
                        :title="i18nValues['remove']"
                        @click="removeOption(scope.row)"
                      ></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
  
          <!-- CANCEL/SAVE --> 
          <div class="full-width d-flex justify-content-end mt-2">
            <el-button :loading="loading" size="small" @click="cancel()">
              {{ i18nValues["cancel"] }}
            </el-button>
            <el-button icon="fas fa-check" :loading="loading" size="small" class="btn-primary" @click="save()">
              {{ i18nValues["save"] }}
            </el-button>
          </div>  
  
        </div>      
      </div>
    </div>
  </template>
  
  <script>
  import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
  export default {
    name: "VariableEdition",  
  
    created(){
  
      if(this.id != 0 ){
          this.retrieveById();
      }
  
      this.rules= {
        name:[{required: true, message: this.i18nValues["requiredValue"], trigger: 'blur' }],
        dataType:[{required: true, message: this.i18nValues["requiredValue"], trigger: 'blur' }],
      };

      this.rulesOption= {
        name:[{required: true, message: this.i18nValues["requiredValue"], trigger: 'blur' }],
      };
  
      this.$store.dispatch("variable/retrieveInspectionTypes", this.variable).then((res) =>{      
        this.inspectionTypes = res;
        if (this.variable && this.variable.inspectionType) {
          console.log(this.variable.inspectionType);  // eslint-disable-line
          this.selectedInspectionTypeId = this.variable.inspectionType.id;
        }
      });

    // Capture initial query to preserve filters/pagination when returning
    this.returnQuery = { ...this.$route.query };

    },
  
    components: {},
  
    computed: {
      loading: get("variable/loading")
    },
  
    props:["id"],
  
    data() {
      return {
  
        variable: {},
  
      rules:{},

        option: {},

        options:[
          {value: 0 , label: "Texto", id: 0},
          {value: 1 , label: "Numerico" , id: 1},
          {value: 2 , label: "Decimal" , id: 2},
          {value: 3 , label: "Opciones" , id: 3},
        ],

        optionsList: [],

        inspectionTypes: [],

        selectedInspectionTypeId: null,

        returnQuery: {},

      };
    },
  
    methods: {
      save(){
        this.$refs["formVariable"].validate((valid) => {
          if(valid){
            if(this.optionsList.length > 0){
              this.variable.optionDefinitions = this.optionsList;
            }
            console.log("ASDF");  // eslint-disable-line
            this.variable.inspectionType = null;
            
            for (var i = 0; i < this.inspectionTypes.length; i++) {
              if (this.selectedInspectionTypeId == this.inspectionTypes[i].id) {
                this.variable.inspectionType = this.inspectionTypes[i];
                break;
              }
            }

            this.$store.dispatch("variable/saveVariable", this.variable).then((res) =>{            
              if(res.status == "OK"){
                  this.$notify.success({
                      title: this.i18nValues["succes"],
                      message: this.i18nValues["variableSaved"],
                      position: "bottom-right",
                  });      
                  this.$router.push({name:"VariableAdmin", query: this.returnQuery});    
              } else {
                  this.$notify.error({
                      title: this.i18nValues["error"],
                      message: this.i18nValues["cantDeleteVariable"],
                      position: "bottom-right",
                  });
              }           
            });
          }
        });
      },
  
      cancel(){
          this.$router.push({name:"VariableAdmin", query: this.returnQuery});
      },
  
      retrieveById(){
          this.$store.dispatch("variable/retrieveVariableById", { id: this.id }).then((res)=>{
              this.variable = res;
              this.optionsList = res.optionDefinitions;

              if (this.inspectionTypes && this.variable.inspectionType && this.variable.inspectionType.id) {
                this.selectedInspectionTypeId = this.variable.inspectionType.id;
              }
          });       
      },

      addOption(){
        this.$refs["formOption"].validate((valid) => {
          if(valid){
            this.optionsList.push(this.option);
            this.option = {};
          }
        });
      },

      removeOption(option){
        this.optionsList.splice(this.optionsList.indexOf(option), 1);
      },

    },
  
  }
  </script>
  
  <style>
  
  </style>